import React from 'react';
import { FmButton } from './FmButton';
import type { FmProductActionDescriptor } from './FmProductPage.types';

const actionVariant = (
  intent: FmProductActionDescriptor['intent'],
): 'primary' | 'bordered' | 'text' => {
  if (intent === 'primary') return 'primary';
  if (intent === 'secondary') return 'bordered';
  return 'text';
};

export const ProductAction: React.FC<{ action: FmProductActionDescriptor }> = ({ action }) => {
  const reasonId = action.disabledReason ? `product-action-${action.id}-reason` : undefined;
  return (
    <span className="fm-product-action">
      <FmButton
        variant={actionVariant(action.intent)}
        size="md"
        onClick={action.onSelect}
        disabled={Boolean(action.disabledReason)}
        aria-describedby={reasonId}
        data-testid={`product-action-${action.id}`}
      >
        {action.label}
      </FmButton>
      {action.disabledReason ? (
        <span id={reasonId} className="fm-product-action__reason">
          {action.disabledReason}
        </span>
      ) : null}
    </span>
  );
};

ProductAction.displayName = 'ProductAction';
